import API from '../api';

export const getStudentResponses = ({
  params: { user, interview, session } = {},
  signal,
} = {}) => {
  return API.get(`/aichatbot/submit_response/`, {
    params: { user, interview, session },
    signal,
  }).then((res) => res?.data);
};

export const getStudentSummary = ({
  params: { interview, session } = {},
  signal,
} = {}) => {
  return API.get(`/aichatbot/summaries/`, {
    params: { interview, session },
    signal,
  }).then((res) => res?.data);
};

export const getAllStudentSummaries = async ({ interview, signal } = {}) => {
  const rows = [];
  let url = '/aichatbot/summaries/';
  let params = { interview, page_size: 100 };
  while (url) {
    const response = await API.get(url, { params, signal });
    const data = response?.data;
    if (Array.isArray(data)) return data;
    rows.push(...(data?.results || []));
    url = data?.next || null;
    params = undefined;
  }
  return rows;
};

export const getStudentSkills = ({
  params: { user, session } = {},
  signal,
} = {}) => {
  return API.get(`/aichatbot/user_skills/`, {
    params: { user, session },
    signal,
  }).then((res) => res?.data);
};

export const exportStudentResponses = ({ interview } = {}) => {
  return API.post(`/aichatbot/export_student_responses/`, {
    interview,
  }).then((res) => res?.data);
};
